/**
 * Microsoft Clarity SPA helpers.
 * Bootstrap (script load) is in public/index.html.
 * Production hosts use REACT_APP_CLARITY_PROJECT_ID.
 * The staging host uses REACT_APP_CLARITY_STAGING_PROJECT_ID.
 */

import { shouldTrackMarketingPageView } from './shared/marketingRouteExclusions';

const PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;
const STAGING_PROJECT_ID = process.env.REACT_APP_CLARITY_STAGING_PROJECT_ID;
const STAGING_HOST = process.env.REACT_APP_CLARITY_STAGING_HOST || 'testing.yovotrip.com';
const ENABLED = process.env.REACT_APP_CLARITY_ENABLED === 'true';

const DEFAULT_ALLOWED_HOSTS = ['yovotrip.com', 'www.yovotrip.com', 'testing.yovotrip.com'];

const ALLOWED_HOSTS = (
  process.env.REACT_APP_CLARITY_ALLOWED_HOSTS || DEFAULT_ALLOWED_HOSTS.join(',')
)
  .split(',')
  .map((host) => host.trim())
  .filter(Boolean);

/**
 * @returns {boolean}
 */
export function isAllowedClarityHostname() {
  if (typeof window === 'undefined') {
    return false;
  }
  return ALLOWED_HOSTS.includes(window.location.hostname);
}

/**
 * Staging hostname loads the staging project. Every other allowed host uses production.
 *
 * @param {string | undefined | null} hostname
 * @param {string | undefined | null} productionId
 * @param {string | undefined | null} stagingId
 * @param {string | undefined | null} [stagingHost]
 * @returns {string}
 */
export function resolveClarityProjectId(hostname, productionId, stagingId, stagingHost = STAGING_HOST) {
  if (hostname && stagingHost && hostname === stagingHost && stagingId) {
    return stagingId;
  }
  return productionId || '';
}

/**
 * @returns {string}
 */
export function activeClarityProjectId() {
  if (typeof window === 'undefined') {
    return PROJECT_ID || '';
  }
  return resolveClarityProjectId(
    window.location.hostname,
    PROJECT_ID,
    STAGING_PROJECT_ID,
    STAGING_HOST
  );
}

/**
 * @returns {boolean}
 */
export function isClarityEnabled() {
  return (
    ENABLED &&
    Boolean(activeClarityProjectId()) &&
    isAllowedClarityHostname() &&
    typeof window !== 'undefined' &&
    typeof window.clarity === 'function'
  );
}

/**
 * Stop recording when the visitor reaches a private or demo route.
 * clarity('stop') ends collection for the rest of the browser session.
 *
 * @param {string | undefined | null} pathname
 */
export function syncClarityRoute(pathname) {
  if (!isClarityEnabled()) {
    return;
  }

  if (!shouldTrackMarketingPageView(pathname)) {
    window.clarity('stop');
  }
}
